var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.305 1.10501C8.12328 0.961415 7.86672 0.961415 7.685 1.10501L0.5 6.71001L1.12 7.50001L2 6.81001V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V6.81501L14.88 7.50001L15.5 6.71501L8.305 1.10501ZM9 13H7V9.00001H9V13ZM10 13V9.00001C10 8.44773 9.55228 8.00001 9 8.00001H7C6.44772 8.00001 6 8.44773 6 9.00001V13H3V6.03001L8 2.13501L13 6.03501V13H10Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.49ddb464efeb0c822da71db9cdf4f96d.svg";
export { ForwardRef as ReactComponent };